import i18next from "i18next";
import i18nextChainedBackend from "i18next-chained-backend";
import i18nextHttpBackend from "i18next-http-backend";

let isI18nInitialized = false;

/**
 * Initialize i18next dynamically
 */
export const initI18n = async (lang: string) => {
  if (isI18nInitialized) {
    i18next.changeLanguage(lang); // Just switch language if already initialized
    return;
  }

  await i18next.use(i18nextChainedBackend).init({
    backend: {
      backends: [i18nextHttpBackend],
      backendOptions: [
        {
          loadPath: `${process.env.REACT_APP_API_URL}/translations/{{lng}}`,
        },
      ],
    },
    lng: lang,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

  isI18nInitialized = true;
};

/**
 * Get translated content with optional replacements
 */
export const getContentV2 = (str: string, arr: (string | number)[] = [], toUpperCase = false): string => {
  const replacements = arr.reduce(
    (acc, value, index) => {
      acc[`text${index + 1}`] = value;
      return acc;
    },
    {} as Record<string, string | number>,
  );

  const text = i18next.t(str, replacements);
  return toUpperCase && text ? text.toUpperCase() : (text ?? str);
};
